import React, { useEffect, useState, useContext } from "react";
export default function ErrorPage() {
  let msg = "404!OOPS";
  return (
    <div>
      <h1>{msg}</h1>
    </div>
  );
}
